import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { Skeleton } from '@material-ui/lab';
import Product from './Organization/Organization';
import useStyles from './styles';
import Loader from "../UI/Loader";
import Pagination from "../Pagination";
import { Euro, Fastfood, FilterHdr, KingBed, ShoppingBasket, LocationOn, Spa, FitnessCenter, Category } from '@material-ui/icons';
import { Button, IconButton, TextField, MenuItem } from '@material-ui/core';
import { UseErrorContext } from '../../global/contexts';
import Page from '../UI/Elements/Page';
import { getOrganizations, getCategories, createLead } from '../../api/services/organization';
import Organization from './Organization/Organization';
import { useHistory } from 'react-router';
import Modal from '../UI/Modal';


const Organizations = ({ search }) => {
  const classes = useStyles();
  const [organizations, setOrganizations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filterCategory, setFilterCategory] = useState(null);
  const [filterFromPrice, setFilterFromPrice] = useState(null);
  const [filterToPrice, setFilterToPrice] = useState(null);
  const [filterLocation, setFilterLocation] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showModalInvite, setShowModalInvite] = useState(false);
  const [inviteName, setInviteName] = useState("");
  const { updateError } = UseErrorContext();
  const history = useHistory();

  useEffect(() => {
    const refresh = async () => {
      try{        
        setLoading(true);

        let params = {
          'categoryId': filterCategory,
          'fromPrice': filterFromPrice,
          'toPrice': filterToPrice,
          'location': filterLocation,
          'status': "Actief",
        };
        if (search){
          params['search'] = search;
        }
        const data = await getOrganizations(params);        
        setOrganizations(data);
  
        setLoading(false);
      } catch (err) {
        console.log(err)
        //updateError(err);
      }
    };

    refresh();
  }, [currentPage, search, filterCategory, filterFromPrice, filterToPrice, filterLocation]);

  useEffect(() => {
    const initCategories = async () => {
      try{        
        setLoading(true);
        const data = await getCategories();    
        setCategories(data);
        setLoading(false);
      } catch (err) {
        console.log(err)
        //updateError(err);
      }
    };
    initCategories();
  }, []);

  const onChangeFilterCategory = (category) => {
    if (filterCategory !== category.id){
      setFilterCategory(category.id);
    }
    else{
      setFilterCategory(null);
    }
  }

  const onChangeFilterPrice = (fromPrice, toPrice) => {
    setFilterFromPrice(filterFromPrice !== fromPrice ? fromPrice : null);
    setFilterToPrice(filterToPrice !== toPrice ? toPrice : null);
  }
  
  const onChangeFilterLocation = (location) => {
    setFilterLocation(filterLocation !== location ? location : null);
  }

  const OpenAboutPage = () => {
    history.push("/over-ons");
  }

  const renderCategoryIcon = (name) => {
    let Icon = FilterHdr;

    switch (name) {
      case 'Eten & Drinken':
        Icon = Fastfood; break;
      case 'Overnachten':
        Icon = KingBed; break;
      case 'Shopping':
        Icon = ShoppingBasket; break;
      case 'Sport':
        Icon = FitnessCenter; break;
      case 'Beauty & Spa':
        Icon = Spa; break;
      case 'Overige':
      default:
        Icon = Category; break;
    }

    return <Icon className={classes.categoryIcon} aria-hidden="true" focusable="false" />;
  }

  const onCategoryKeyDown = (e, category) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onChangeFilterCategory(category);
    }
  };

  const _sendInvite = async () => {
    await createLead(inviteName);
    setInviteName("");
    setShowModalInvite(false);
  }

  return (
    <>
      {showModalInvite && (
        <Modal title={`Winkel uitnodigen`} onClose={() => setShowModalInvite(false)} onSubmit={() => _sendInvite()} cancelLabel={"Annuleer"} submitLabel={"Bevestig"}>
          <TextField label="Naam" onChange={(e) => setInviteName(e.target.value)} fullWidth value={inviteName}/>
        </Modal>
      )}  
      <div className={classes.kerst}>
        <div></div>
        <Page noBackground={true} className={classes.page}>
          <div className={classes.info}>
            <span className={classes.heroBadge}>✨ Lokaal cadeau geven, eenvoudig en snel</span>
            <h1>Ontdek de leukste <i>cadeaubonnen</i> van jouw favoriete lokale winkels en handelaars</h1>
            <p>Van een gezellig restaurant of stijlvolle modewinkel tot een avontuurlijk uitje of een dagje wellness — vind voor iedereen het perfecte cadeau in één paar klikken.</p>
            <span>Wil jij ook jouw cadeaubonnen hier verkopen?</span><br></br>
            <IconButton className={classes.iconButton} size="small" onClick={() => OpenAboutPage()}>
              🚀 Nu lid worden!
            </IconButton>
          </div>
          <div className={classes.topbar}>
              {categories.map((category, idx) => (
                <div
                  className={classes.categoryCard + `${filterCategory == category.id ? ' ' + classes.active : ''} `}
                  key={idx}
                  onClick={() => onChangeFilterCategory(category)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => onCategoryKeyDown(e, category)}
                  aria-pressed={filterCategory == category.id}
                >
                  <div className={classes.categoryImgBox} aria-label={category.name}>{renderCategoryIcon(category.name)}</div>
                  <p className={classes.categoryText}>{category.name}</p>
                </div>
              ))}
          </div>
          <div className={classes.categoryDropdown}>
            <TextField
              select
              fullWidth
              variant="outlined"
              label="Categorie"
              value={filterCategory || ''}
              onChange={(e) => setFilterCategory(e.target.value || null)}
            >
              <MenuItem value="">Alle categorieën</MenuItem>
              {categories.map((category) => (
                <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
              ))}
            </TextField>
          </div>
            <div className={classes.content}> 
              <div className={classes.filters}>
                <Button variant="outlined" className={`${(filterFromPrice == "0" && filterToPrice == "50") ? 'customButton' : 'customButton2'}`} startIcon={<Euro/>} onClick={() => onChangeFilterPrice(0, 50)}>Onder de 50</Button>
                <Button variant="outlined" className={`${(filterFromPrice == "50" && filterToPrice == "100") ? 'customButton' : 'customButton2'}`} startIcon={<Euro/>} onClick={() => onChangeFilterPrice(50, 100)}>Tussen de 50 en 100</Button>
                <Button variant="outlined" className={`${(filterFromPrice == "100" && filterToPrice == "0") ? 'customButton' : 'customButton2'}`} startIcon={<Euro/>} onClick={() => onChangeFilterPrice(100, 0)}>Boven de 100</Button>
                {/* <Button variant="outlined" className={`${filterLocation == "Antwerpen" ? 'customButton' : 'customButton2'} `} startIcon={<LocationOn/>} onClick={() => onChangeFilterLocation("Antwerpen")}>Antwerpen</Button> */}
              </div> 
              {loading 
              ? <Loader center />
              : <div className={classes.items}>         
                  <Grid container alignItems="stretch" className={classes.grid}>
                  { organizations.length === 0
                    ? <p>Geen resultaten gevonden</p>
                    : <>
                        {organizations.map((organization, idx) => (
                        <Grid key={organization.id} item xs={12} sm={6} md={4} lg={3}>
                          { organization 
                            ? (<Organization organization={organization} idx={idx}/>)
                            : (<Skeleton variant="rect" width={210} height={118} />)
                          }
                        </Grid>
                        ))}
                      </>
                  }
                  </Grid>
                  <Pagination numberOfPages={numberOfPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                </div>
              }
              <div className={classes.invite}>
                <IconButton className={classes.iconButton2} onClick={() => setShowModalInvite(true)}><span>Winkel of zaak niet gevonden? Nodig ze <u>hier</u> uit om deel te nemen!</span></IconButton>
              </div>
            </div>
        </Page>
      </div>
    </>
  );
};

export default Organizations;

